import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage } from '../utils/functions/localstorage';
import { ROLES } from '../utils/constants'
import { checkAccessRights } from '../utils/functions/accessRight'

const USER = process.env.REACT_APP_API_URL
const ADMIN = process.env.REACT_APP_API_URL_admin

const baseQuery = fetchBaseQuery({
   // ✅ เพิ่ม checkAccessRights(ROLES.SALE_ROLE) เพื่อให้ SALE วิ่งไปใช้ ADMIN URL
   baseUrl: `${
     checkAccessRights(ROLES.ADMIN_ROLE) || 
     checkAccessRights(ROLES.SUPER_ADMIN_ROLE) || 
     checkAccessRights(ROLES.SALE_ROLE) 
       ? ADMIN 
       : USER
   }/payment-transaction`,
   
   prepareHeaders: (headers) => {
     const token = getStorage('token');
     if (token) {
       headers.set('authorization', `Bearer ${token}`);
     }
     return headers;
   },
});

export const groupBankApi = createApi({
  reducerPath: 'groupBankApi',
  baseQuery,
  endpoints: (builder) => ({
    getGroupBankAll: builder.query({
        query: () => '/bank-account',
    }),
  }),
});

export const { useGetGroupBankAllQuery } = groupBankApi;